import React, { useMemo, useState } from 'react';

import { TariffVerificationTypeEnum } from '@src/core/buyerApiClient';
import BaseInput from '@src/components/reusable/input/BaseInput';
import MaskedInput from '@src/components/reusable/input/MaskedInput';
import { isoToDateMask } from '@src/common/dateMask';

type VerificationInputProps = {
  fieldKey: string;
  initialValue: string;
  inputLabel: string;
  onValueChange: (value: string) => void;
  type: TariffVerificationTypeEnum;
  hasError: boolean;
  errorMessage?: string;
};

const VerificationInput = ({
  fieldKey,
  initialValue,
  inputLabel,
  onValueChange,
  type,
  hasError,
  errorMessage,
}: VerificationInputProps) => {
  const [value, setValue] = useState<string | undefined>(undefined);

  const initialValueFormatted = useMemo(
    () => (type === TariffVerificationTypeEnum.Date ? isoToDateMask(initialValue) : initialValue),
    [initialValue, type],
  );

  const handleChange = (next: string) => {
    setValue(next);
    onValueChange(next);
  };

  if (type === TariffVerificationTypeEnum.Date) {
    return (
      <MaskedInput
        name={fieldKey}
        label={inputLabel}
        value={value}
        error={hasError}
        helperText={errorMessage}
        defaultValue={initialValueFormatted}
        mask='__/__/____'
        replacement={{ _: /\d/ }}
        placeholder='DD/MM/YYYY'
        onChange={(e) => handleChange(e.target.value)}
      />
    );
  }

  return (
    <BaseInput
      type='text'
      name={fieldKey}
      error={hasError}
      helperText={errorMessage}
      placeholder={inputLabel}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
    />
  );
};

export default VerificationInput;
